import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { changeReCountNotifications } from '../../../layout/store/slice'
import { changeIsRead, changeIsScroll } from '../../store/slice'
import { updateReadStatus } from '../../store/thunk'
import { getNotificationTimeTitle } from '../helper'

const Message = ({
  isRead,
  title,
  createdAt,
  url,
  id,
  screenType,
  timeType,
}) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)

  const { title: timeTitle, value } = getNotificationTimeTitle(
    createdAt,
    locale,
  )

  const handleRedirect = () => {
    if (!isRead) {
      updateStatus()
    }

    if (!url) return

    window.open(url)
  }

  const updateStatus = () => {
    dispatch(
      updateReadStatus({
        ids: [id],
        isRead: true,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeIsScroll(false))
        dispatch(
          changeIsRead({
            screenType,
            timeType,
            id,
            isRead: true,
          }),
        )
        dispatch(changeReCountNotifications())
      })
      .catch(() => {})
  }

  return (
    <div
      onClick={handleRedirect}
      className="flexColumn flex1"
      style={{ columnGap: '4px' }}
    >
      <Element
        style={{
          fontSize: 12,
          lineHeight: '16px',
          fontWeight: !isRead ? 600 : 400,
          color: '#3A414B',
        }}
      >
        {title}
      </Element>
      <Element
        style={{
          fontSize: 12,
          lineHeight: '16px',
          color: !isRead ? '#0553A5' : '#9C9C9C',
        }}
      >
        {value}
        {timeTitle && (
          <Translate value={`systemNotificationsSettings.${timeTitle}`} />
        )}
      </Element>
    </div>
  )
}

export default Message
